import type { ComponentProps } from 'react'

import { ICON_DEFAULT_COLOR, ICON_DEFAULT_FILL, type IconProps } from 'components'

export const CopyCheck = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = '24', // TODO: Replace with ICON_DEFAULT_WIDTH when migration to ION is complete
  height = '24', // TODO: Replace with ICON_DEFAULT_HEIGHT when migration to ION is complete
  viewBox = '0 0 24 24', // TODO: Replace with ICON_DEFAULT_VIEWBOX when migration to ION is complete
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.502 12.5049C17.7753 12.2315 18.2188 12.2315 18.4922 12.5049C18.7656 12.7782 18.7656 13.2218 18.4922 13.4951L14.4922 17.4951C14.2188 17.7685 13.7753 17.7685 13.502 17.4951L11.502 15.4951C11.2286 15.2218 11.2286 14.7782 11.502 14.5049C11.7753 14.2315 12.2188 14.2315 12.4922 14.5049L13.9971 16.0098L17.502 12.5049Z"
        fill={color}
      />
      <path
        d="M21.2969 10C21.2969 9.28203 20.715 8.7002 19.9971 8.7002H9.99707C9.2791 8.7002 8.69727 9.28203 8.69727 10V20C8.69727 20.718 9.2791 21.2998 9.99707 21.2998H19.9971C20.715 21.2998 21.2969 20.718 21.2969 20V10ZM22.6973 20C22.6973 21.4912 21.4882 22.7002 19.9971 22.7002H9.99707C8.5059 22.7002 7.29688 21.4912 7.29688 20V10C7.29688 8.50883 8.5059 7.2998 9.99707 7.2998H19.9971C21.4882 7.2998 22.6973 8.50883 22.6973 10V20Z"
        fill={color}
      />
      <path
        d="M15.2969 4C15.2969 3.2866 14.7105 2.7002 13.9971 2.7002H3.99707C3.28367 2.7002 2.69727 3.2866 2.69727 4V14C2.69727 14.7134 3.28367 15.2998 3.99707 15.2998C4.38367 15.2998 4.69727 15.6134 4.69727 16C4.69727 16.3866 4.38367 16.7002 3.99707 16.7002C2.51047 16.7002 1.29688 15.4866 1.29688 14V4C1.29688 2.5134 2.51047 1.2998 3.99707 1.2998H13.9971C15.4837 1.2998 16.6973 2.5134 16.6973 4C16.6973 4.3866 16.3837 4.7002 15.9971 4.7002C15.6105 4.7002 15.2969 4.3866 15.2969 4Z"
        fill={color}
      />
    </svg>
  )
}
